import React, { PureComponent, createRef } from 'react';
import ScrollLock from './ScrollLock';

export default class ScrollBlock extends PureComponent {
  scrollTargetRef = createRef();

  state = { touchScrollTarget: null };

  componentDidMount() {
    if (this.scrollTargetRef.current) {
      this.setState({ touchScrollTarget: this.scrollTargetRef.current });
    }
  }

  // this will close the menu when a user clicks outside
  blurSelectInput = () => {
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  render() {
    const { children, isEnabled } = this.props;
    const { touchScrollTarget } = this.state;

    // bail early if not enabled
    if (!isEnabled) {
      return children;
    }

    /*
     * Div
     * ------------------------------
     * blocks scrolling on non-body elements behind the menu
     *
     * span with ref
     * ------------------------------
     * we need a reference to the scrollable element to "unlock" scroll on
     * mobile devices
     *
     * ScrollLock
     * ------------------------------
     * actually does the scroll locking
     */
    return (
      <div>
        <div
          onClick={this.blurSelectInput}
          // css={{ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 }}
        />
        <span ref={this.scrollTargetRef}>{children}</span>
        {touchScrollTarget ? (
          <ScrollLock touchScrollTarget={touchScrollTarget} />
        ) : null}
      </div>
    );
  }
}
